// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1NsuL","right":"styles_right__8KnPZ"};